import React from "react";

const Benificiaries = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        N.
        <span className="text-[#01A7D1] "> NO THIRD-PARTY BENEFICIARIES</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <span className="text-lg font-medium">
          You agree that, except as otherwise expressly provided in the Terms of
          Use, there shall be no third-party beneficiaries to the Terms of Use.
        </span>
      </p>
    </div>
  );
};

export default Benificiaries;
